export default __webpack_public_path__ + "static/media/cross.993acdb8.png";